import React from "react";
import { Text } from "rsuite";

import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-container">
            <Text className="brand-text-main">{`Megha Smart Trading`}</Text>
            <h1 className="error-boundary-title">
              Oops! Something Went Wrong.
            </h1>
            <p className="error-boundary-message">
              We encountered an issue while processing your request. Please
              contact us for assistance.
            </p>
            <p className="error-boundary-contact-info">
              Email:{" "}
              <a href="mailto:support@example.com">support@example.com</a>
              <br />
              Phone: <a href="tel:+1234567890">+1 (234) 567-890</a>
            </p>
            <p className="error-boundary-advice">
              We apologize for the inconvenience and will work to resolve this
              issue as quickly as possible.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
